var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoGoogleSheets = function SvgLogoGoogleSheets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.887 44.161c0 1.491-1.22 2.7-2.725 2.7H2.725C1.22 46.862 0 45.653 0 44.162V2.85C0 1.359 1.22.15 2.725.15H21.01l12.878 13.067v30.944Z",
    fill: "#23A566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.428 12.886 33.888 23.73l-.034-10.53-.019-.001H23.712c-.462 0-.896-.114-1.277-.314h-.006Z",
    fill: "#1C8F5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.887 13.2H23.712c-1.505 0-2.726-1.21-2.726-2.7V.138L33.887 13.2Z",
    fill: "#8ED1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.131 38.221h17.625v-15.12H8.13v15.12Zm9.902-10.26h5.542v-2.7h-5.542v2.7Zm0 4.14h5.542v-2.52h-5.542v2.52Zm0 3.96h5.542v-2.34h-5.542v2.34Zm-7.722 0h5.542v-2.34h-5.541v2.34Zm0-3.96h5.542v-2.52h-5.541v2.52Zm0-4.14h5.542v-2.7h-5.541v2.7Z",
    fill: "#fff"
  })));
};

export default SvgLogoGoogleSheets;